export const CUSTOMIZATION_ACTIONS = {
  GET_CUSTOMIZATION_IN_PROGRESS: "GET_CUSTOMIZATION_IN_PROGRESS",
  GET_CUSTOMIZATION_SUCCEEDED: "GET_CUSTOMIZATION_SUCCEEDED",
  GET_CUSTOMIZATION_FAILED: "GET_CUSTOMIZATION_FAILED",
};
